import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Chip,
} from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import { format } from "date-fns";

const LastMessageCard = ({ messages = [] }) => {
  if (messages.length === 0) {
    return (
      <Card>
        <CardContent>
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <MessageIcon color="disabled" />
            <Typography variant="subtitle1" fontWeight="bold">
              MQTT Messages
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            No messages received yet.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <MessageIcon color="primary" />
          <Typography variant="subtitle1" fontWeight="bold">
            MQTT Messages
          </Typography>
          <Chip label={messages.length} size="small" variant="outlined" />
        </Box>

        <Typography variant="caption" color="text.secondary" display="block">
          {messages[0]?.topic}
        </Typography>

        <Divider sx={{ my: 1.5 }} />

        <Box
          sx={{
            maxHeight: 500,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {messages.map((msg, i) => {
            const timestamp = msg.timestamp
              ? format(new Date(msg.timestamp), "h:mm:ss a")
              : "";

            return (
              <Box key={msg.timestamp || i}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ mb: 0.5, display: "block" }}
                >
                  {timestamp}
                </Typography>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: 1,
                    bgcolor: "grey.900",
                    color: "grey.100",
                    fontFamily: "monospace",
                    fontSize: 11,
                    overflow: "auto",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all",
                  }}
                >
                  {JSON.stringify(msg.payload, null, 2)}
                </Box>
              </Box>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );
};

export default LastMessageCard;
